import React from 'react';
import { Tooltip } from 'antd-v5';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { HowItWorksIcon1, HowItWorksIcon2, HowItWorksIcon3, HowItWorksIcon4, QuestionIcon } from '@/components/EcoCredits/Svg';

const HowItWorks: React.FC = () => {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecocredits.howitworks');

    const data = [
        {
            key: '1',
            icon: <HowItWorksIcon1 />,
            title: t('sign_up'),
            text: t('sign_up_desc'),
        },
        {
            key: '2',
            icon: <HowItWorksIcon2 />,
            title: t('earn_points'),
            text: t('earn_points_desc'),
        },
        {
            key: '3',
            icon: <HowItWorksIcon3 />,
            title: t('redeem_points'),
            text: t('redeem_points_desc'),
        },
        {
            key: '4',
            icon: <HowItWorksIcon4 />,
            title: t('more_benefits'),
            text: t('more_benefits_desc'),
            question: t('more_benefits_question'),
        },
    ];

    return (
        <div className={`${styled.HowItWorks} main-page`} id="HOW_IT_WORKS">
            <div className="ecocredits-over"></div>
            <h5 className="ecocredits-title">
                {t('how_it_works')}
                <Link href={`https://${locale}.ecoflow.com/pages/rewards-guide`}>
                    <QuestionIcon />
                </Link>
            </h5>

            <ul className="list">
                {data.map((item) => (
                    <li key={item.key} className="item">
                        <div>
                            <div className="icon">{item.icon}</div>
                            <h6 className="item-title">
                                {item.title}
                                {item.question && (
                                    <Tooltip placement="bottom" title={item.question}>
                                        <QuestionIcon />
                                    </Tooltip>
                                )}
                            </h6>
                        </div>
                        <p className="item-text">{item.text}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HowItWorks;
